import MainLayout from "@/components/layout/admin/MainLayout.vue";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import {
  required,
  maxLength
} from "vuelidate/lib/validators";
import axios from "axios";
import store from '@/store';
import ValidationService from "@/services/ValidationService";

export default {
  name: "termCreate",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
  },

  mixins: [ValidationService],

  data() {
    return {
      termData: {
        term_name: '',
        start_date: '',
        end_date: '',
        login_id: store.state.user.id
      },
      acdYearStart: null,
      acdYearEnd: null,
      isError: false,
      submitted: false,
      campusId: store.state.user.campus_master.campus_code,
      disabled: false,
      acdYearId: this.$route.params.acdYearId ? Number(this.$route.params.acdYearId) : 0,
    };
  },

  validations: {
    termData: {
      term_name: {
        required,
        maxLength: maxLength(255)
      },
      start_date: {
        required
      },
      end_date: {
        required
      }
    },
  },

  watch: {
    "termData.start_date"() {
      this.validationErrors.end_date = [];
    },

    "termData.end_date"() {
      this.validationErrors.end_date = [];
    }
  },

  methods: {
    deleteError(key) {
      delete this.validationErrors[key];
    },
    
    create() {
      if (this.disabled) return;

      this.submitted = true;
      if (this.termData.start_date && this.termData.end_date && new Date(this.termData.end_date) <= new Date(this.termData.start_date)) {
        this.isError = true;
      } else {
        this.isError = false;
      }

      if (this.$v.$invalid || this.isError) {
        this.disabled = false;
        return;
      }

      this.disabled = true;
      axios.post('period/' + this.acdYearId + '/term/create', this.termData)
        .then(res => {
          if (res.status == 201) {
            this.$notification.success("Term added successfully.", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'periodDetail',
              params: { id: this.acdYearId }
            })
          } else {
            this.disabled = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch((error) => {
          this.disabled = false;
          this.isLoading = false;
          if (error.response) {
            this.printValidationError(error.response);
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
          }
        });
    },
  },

  mounted() {
    this.isLoading = true;
    if (!this.$route.params.acdYearId) {
      this.getAcademicYears();
    } else {
      this.isLoading = false;
    }
  }
};
